import { OPEN_MODAL_REASSIGN_ADVISOR } from '../actionTypes';
import { creditsActions } from '../reducer';

export default (value) => creditsActions[OPEN_MODAL_REASSIGN_ADVISOR](value);
